// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"fR-z","smallCardRow":"gR-z","largeCardRow":"hR-z","productSearchRow":"iR-z","curatedRow":"jR-z"};